import gql from 'graphql-tag';

import { TaskFragment } from 'common/components/TasksWidget/queries';

export const myTaskCreated = gql`
  subscription myTaskCreated($startedBy: ID!) {
    create: taskCreated(startedBy: $startedBy) {
      ...Task
    }
  }
  ${TaskFragment}
`;

export const myTaskUpdated = gql`
  subscription myTaskUpdated($id: ID!) {
    update: taskUpdated(id: $id) {
      ...Task
    }
  }

  ${TaskFragment}
`;
